module.exports = __webpack_public_path__ + "static/media/footer-banner.57fc935f.png";